// extracted by mini-css-extract-plugin
export default {"help-footer":"cr1Yl","help-footer__title":"al0pB"};